import React, {useState, useEffect} from 'react'

import classes from './Star.module.css'

const Star = ({filled, children}) => {


    return (
    <div className={classes.Star}>
      {!filled &&
      <svg
      viewBox="32 33 155 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">

        <path
        d="M64.1758 159.661C62.3589 167.457 70.8511 173.456 77.6355 169.395L108.424 150.962C109.392 150.382 110.608 150.382 111.576 150.962L142.365 169.395C149.149 173.456 157.641 167.457 155.824 159.661L147.721 124.894C147.472 123.826 147.836 122.702 148.682 121.974L175.867 98.5836C181.939 93.3591 178.656 83.5104 170.736 82.8281L134.79 79.7313C133.659 79.6338 132.688 78.9249 132.256 77.9095L118.319 45.1821C115.206 37.8722 104.794 37.8723 101.681 45.1821L87.7441 77.9095C87.3116 78.9249 86.3413 79.6338 85.2098 79.7313L49.2638 82.8281C41.344 83.5104 38.0615 93.3592 44.1333 98.5836L71.3176 121.974C72.1641 122.702 72.528 123.826 72.2791 124.894L64.1758 159.661Z"
        fill="url(#paint0_radial_960_8506)"
        stroke="url(#paint1_linear_960_8506)"
        strokeWidth={6}
        />
      <defs>
        <radialGradient
          id="paint0_radial_960_8506"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(110 124.5) rotate(0.369642) scale(77.5016 43.5009)"
        >
          <stop stopColor="#30457F" />
          <stop offset={1} stopColor="#090F37" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_960_8506"
          x1={110}
          y1={42.6997}
          x2={110}
          y2={167.7}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4646A0" />
          <stop offset={1} stopColor="#7C7CD3" />
        </linearGradient>
      </defs>
      </svg>}


      {filled &&
      <svg viewBox="25 25 168 158" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path
        d="M60.2803 158.753C57.6429 170.069 69.9477 178.659 79.6902 172.827L110 154.68L140.31 172.827C150.052 178.659 162.357 170.069 159.72 158.753L151.76 124.603L178.476 101.616C187.272 94.047 182.477 79.8248 171.079 78.8429L135.703 75.7951L121.999 43.6149C117.505 33.0613 102.495 33.0614 98.0008 43.6149L84.2969 75.7951L48.9205 78.8429C37.5231 79.8248 32.7281 94.047 41.5244 101.616L68.2398 124.603L60.2803 158.753ZM109.522 154.394L109.524 154.395L109.522 154.394ZM135.936 76.3423L135.935 76.3402C135.936 76.3409 135.936 76.3416 135.936 76.3423L135.05 76.7198L135.936 76.3423Z"
        fill="#070D2F"
        stroke="url(#paint0_linear_960_8143)"
        strokeWidth={14} />

        <path
          d="M63.202 159.735C61.1799 168.41 70.6253 175.058 78.1492 170.553L108.937 152.12C109.59 151.73 110.41 151.73 111.063 152.12L141.851 170.553C149.375 175.057 158.82 168.41 156.798 159.735L148.695 124.968C148.531 124.264 148.769 123.519 149.335 123.032L176.519 99.6419C183.272 93.8314 179.611 82.8893 170.822 82.1321L134.876 79.0353C134.11 78.9693 133.462 78.4905 133.176 77.818L119.239 45.0906C115.781 36.9698 104.219 36.9698 100.761 45.0906L86.824 77.818C86.5376 78.4905 85.8899 78.9693 85.1239 79.0353L49.178 82.1321C40.3888 82.8893 36.7281 93.8314 43.4811 99.6419L70.6654 123.032C71.2311 123.519 71.4692 124.264 71.3052 124.968L63.202 159.735Z"
          fill="url(#paint1_linear_960_8143)"
          stroke="#081036"
          strokeWidth={8}
        />
        <path
          d="M67.0975 160.643C65.8958 165.799 71.5287 169.855 76.0945 167.121L80.0762 164.737C80.0831 164.706 80.0902 164.674 80.0975 164.643C65 164.737 84.7923 144.5 88.2008 129.876C88.7045 127.714 87.9633 125.454 86.2743 124L59.09 100.61C55.0615 97.1436 57.2096 90.5749 62.5213 90.1173L98.4673 87.0205C100.695 86.8286 102.634 85.4296 103.504 83.3852L110.465 53.2918C111.179 50.2049 114.861 48.9088 117.352 50.8678L115.559 46.6578C113.482 41.7807 106.518 41.7808 104.441 46.6578L90.5042 79.3852C89.6336 81.4296 87.6952 82.8286 85.4673 83.0205L49.5213 86.1173C44.2096 86.5749 42.0615 93.1436 46.09 96.6098L73.2743 120C74.9633 121.454 75.7045 123.714 75.2008 125.876L67.0975 160.643Z"
          fill="white"
          fillOpacity={0.8}
          style={{
            mixBlendMode: "overlay",
          }}
        />
        <path
          d="M134.5 83C135.432 84.8614 145.429 88.8392 147.533 89.0205L176 93.5C177 88 172.786 86.3161 170.479 86.1173L134.5 83Z"
          fill="white"
          fillOpacity={0.8}
          style={{
            mixBlendMode: "overlay",
          }}
        />
        <path
          d="M152.5 162.5C146 167.121 138.5 156 122.117 148.688C120.2 147.54 113.917 147.352 112 148.5L143.906 167.121C146.033 168.395 152.5 168.5 152.5 162.5Z"
          fill="white"
          fillOpacity={0.8}
          style={{
            mixBlendMode: "overlay",
          }}
        />
      <defs>
        <linearGradient
          id="paint0_linear_960_8143"
          x1={110}
          y1={42.6997}
          x2={110}
          y2={167.7}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4646A0" />
          <stop offset={1} stopColor="#7C7CD3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_960_8143"
          x1={67.9092}
          y1={43}
          x2={152.091}
          y2={168}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.326539} stopColor="#FFE478" />
          <stop offset={0.896} stopColor="#FFAF47" />
        </linearGradient>
      </defs>
      </svg>}

      {children && <div className={classes.content}>{children}</div>}
    </div>)
}



export default Star;
